import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import useStores from "@hooks/useStores";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import ContentMath from "./ContentMath";
import ContentAsset from "./ContentAsset";

const ContentSideInfoBox = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();
	const sideInfoBox = store.content.sideInfoBox;

	if (!sideInfoBox) {
		return "";
	}

	const sideName = store.content.sideInfoBox.name;
	const sideImg = store.content.sideInfoBox.image
		? store.content.sideInfoBox.image[0].secure_url
		: "";
	const sideDescription = store.content.sideInfoBox.description;

	const sideInfoBoxDetail = sideInfoBox.detail;
	const options = {
		renderNode: {
			[INLINES.EMBEDDED_ENTRY]: (node) => {
				const entry = store.findLinkedEntity(
					node,
					sideInfoBoxDetail.links?.entries
				);
				if (!entry) return;
				switch (entry.__typename) {
					case "Math":
						return <ContentMath {...entry} />;
				}
			},
			[BLOCKS.EMBEDDED_ENTRY]: (node) => {
				const entry = store.findLinkedEntity(
					node,
					sideInfoBoxDetail.links?.entries
				);
				if (!entry) return;
				switch (entry.__typename) {
					case "Math":
						return <ContentMath {...entry} />;
				}
			},
			[INLINES.ENTRY_HYPERLINK]: (node, children) => {
				const entry = store.findLinkedEntity(
					node,
					sideInfoBoxDetail.links?.entries
				);
				if (!entry) return;
				return (
					<a href={`${entry.folder}${entry.slug}`} target="_blank">
						{children}
					</a>
				);
			},
			[INLINES.HYPERLINK]: (node, children) => {
				return (
					<a href={`${node.data.uri}`} target="_blank">
						{children}
					</a>
				);
			},
			[BLOCKS.EMBEDDED_ASSET]: (node) => {
				const asset = store.findLinkedEntity(
					node,
					sideInfoBoxDetail.links?.assets
				);
				if (!asset) return;
				return <ContentAsset {...asset} />;
			},
		},
	};

	const SideInfoBoxDetail = () =>
		documentToReactComponents(store.content.sideInfoBox?.detail?.json, options);

	return (
		<Box mb={8}>
			<Paper variant={"outlined"}>
				<div className={classes.asideBox}>
					<div className={classes.asideBoxHeader}>{sideName}</div>
				</div>
				<Box py={8} px={6} className={classes.body}>
					<p>
						<Box
							component={"img"}
							borderRadius={4}
							width={"100%"}
							src={sideImg}
							alt={sideName}
							title={sideDescription}
						/>
					</p>

					<Box component={"p"} style={{ fontSize: 16 }}>
						{sideDescription}
					</Box>

					<Box mb={8}>
						<Divider light />
					</Box>

					<div className={classes.sideBoxDetails}>
						<SideInfoBoxDetail />
					</div>

					{/* {sideInfoBoxItems.map(({ item, answer }) => (
						<Box mt={2}>
							<strong>{item}</strong> {answer}
						</Box>
					))} */}
				</Box>
			</Paper>
		</Box>
	);
};

ContentSideInfoBox.propTypes = {};
export default ContentSideInfoBox;
